import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import Contract from "slotworks/utils/contracts/contract";

export default class AGSAnimateBehaviour extends AnimateSymbolBehaviour {

    public win(): Contract<void> {
        return this.animate("_win", [this.defaultAnimation], false, true);
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
